import React, {useEffect, useState} from 'react';
import Card from "../ui/card/card";
import YouAreAnonymous from "../ui/anonymous/anonymous";
import PoweredBy from "../ui/poweredBy/poweredBy";
import HelpLineTitle from "../ui/helpline-title/helplineTitle";
import { styled } from "styled-components";
import Question from "../ui/form/question";
import useDataStore from "../data/store/useDataStore";
import Button from "../ui/button/button";
import { useNavigate, useParams } from "react-router";
import { t } from 'ttag';

const Wrapper = styled.div`
  .HelpLineTitle {
    width: 300px;
    padding: 10px;
    position: absolute;
    left: 20px;
    top: 20px;
    background-color: #FFF;
    border-radius: 20px;
    -webkit-box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
    -moz-box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
    box-shadow: 2px 3px 19px -9px rgba(66, 68, 90, 1);
    p {
      font-size: 12px;
      margin: 0px;
    }
    img {
      width: 68px;
      margin-top: 0px;
    }
  }
  
  textarea {
    border-radius: 5px;
    border: 1px solid #ccc;
    background: #FFF;
    width: 100%;
    height: 100px;
  }
  
  .qPart {
    width: unset;
  }
  
  @media (max-width: 768px) {
    padding-top: 60px;
    
    .HelpLineTitle {
      width: 250px;
    }
    
    .anonymousBlock {
      padding: 8px;
      span {
        display: none;
      }
    }
  }
`;

const Questions = () => {

  const navigate = useNavigate();
  const { companyId, categoryId } = useParams();

  const { questions, resetAnswers, questionCategories, fetchData, setCompanyId } = useDataStore();
  const [ categoryName, setCategoryName ] = useState('');
  const [ questionsForm, setQuestionsForm ] = useState([]);

  const question = questionsForm.filter(i => i.answer).length;

  useEffect(() => {
    if (categoryId) {

      if (questionCategories) {
        const _category = questionCategories.find(i => i.id == categoryId);
        if (_category) {
          setCategoryName(`${_category.icon} ${_category.title}`);
        }
      }
      if (questions) {
        const elementsForForm = questions.filter(i => i.questionCategoryId == categoryId);
        setQuestionsForm(elementsForForm);
      }
    } else {
      navigate(`/${companyId || ''}`);
    }
  }, [categoryId, questions]);

  useEffect(() => {
    if (companyId && categoryId && !questions) {
      setCompanyId(companyId);

      setTimeout(() => {
        fetchData();
      }, 100);
    }
  }, []);

  return (
    <Wrapper>
      <HelpLineTitle />
      <YouAreAnonymous show={true} />
      <div className='root'>
        <Card>
          <section>
            <h2>{categoryName}</h2>
            {(questionsForm && questionsForm.length && questionsForm.length == question) ? <h2>{t`Review your Submission`}</h2> : false}
            {questionsForm ? (questionsForm.map((q, index) => (index <= question) && <Question key={`q_${index}`} data={q} />)) : false}
            {(questionsForm && questionsForm.length && questionsForm.length == question) ? (
              <div>
                <Button className="m-2" title={t`Save & Submit`} onClick={() => navigate(`/${companyId}/question/${categoryId}/beforeYouGo`)} />
                <Button className="m-2" title={t`Start again`} onClick={resetAnswers} />
              </div>
            ) : false }
          </section>
        </Card>
      </div>
      <PoweredBy />
    </Wrapper>
  );
};

export default Questions;
